<template>
  <el-dialog
    class="point_select"
    :visible.sync="visible"
    width="800px"
    append-to-body
  >
    <p slot="title" class="dialog_title">{{ community.name + '点位选择' }}</p>
    <template v-if="showDeviceList">
      <DeviceList key='inner' v-if="curDeviceType==='inner'" :buildingList="community.buildDeviceList"
                  :isExport="isExport" @change="innerChange"></DeviceList>
      <DeviceList key='outer' v-if="curDeviceType==='outer'" :buildingList="community.twBuildDeviceList"
                  :isExport="isExport" @change="outerChange"></DeviceList>
    </template>
    <div v-else class="empty_div">暂无{{curDeviceType === 'inner'?'梯内':'梯外'}}屏哦~</div>
    <div slot="footer" class="p_footer">
      <el-button size="mini" type="primary" @click="submitData" class="btn sure_btn_x">确认</el-button>
      <el-button size="mini" @click="visible=false" class="btn">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import DeviceList from './DeviceList'

export default {
  name: 'CommunitySelect',
  components: { DeviceList },
  data () {
    return {
      visible: false,
      community: {},
      isExport: true,
      curDeviceType: 'inner'
    }
  },
  computed: {
    showDeviceList () {
      let { buildDeviceList, twBuildDeviceList } = this.community
      const showTnDeviceList = buildDeviceList && buildDeviceList.length && this.curDeviceType === 'inner'
      const showTwDeviceList = twBuildDeviceList && twBuildDeviceList.length && this.curDeviceType === 'outer'
      return showTnDeviceList || showTwDeviceList
    }
  },
  methods: {
    show (data, isExport) {
      this.visible = true
      this.isExport = isExport
      this.curDeviceType = 'inner'
      this.setDefault(JSON.parse(JSON.stringify(data)))
    },
    setDefault (data) {
      let checkAll = data.allSelectDeviceCount === data.allDeviceCount
      let noCheck = data.allSelectDeviceCount === 0
      this.setDeviceCheck(data.buildDeviceList, checkAll, noCheck)
      this.setDeviceCheck(data.twBuildDeviceList, checkAll, noCheck)
      let { name, guid, twSelectDeviceCount, tnSelectDeviceCount, twSelectSlotAmount, tnSelectSlotAmount, tnAllDeviceCount, twAllDeviceCount } = data
      this.community = {
        name,
        guid,
        twSelectDeviceCount,
        tnSelectDeviceCount,
        twSelectSlotAmount,
        tnSelectSlotAmount,
        tnAllDeviceCount,
        twAllDeviceCount
      }
      this.$set(this.community, 'buildDeviceList', data.buildDeviceList || [])
      this.$set(this.community, 'twBuildDeviceList', data.twBuildDeviceList || [])
    },
    setDeviceCheck (buildingList, checkAll, noCheck) {
      if (!buildingList) return
      buildingList.forEach(building => {
        building.showContent = false
        if (checkAll) {
          building.selectDeviceCount = building.allDeviceCount
          building.check = true
        } else if (noCheck) {
          building.selectDeviceCount = 0
          building.selectSlotAmount = 0
          building.check = false
        }
        building.unitDeviceList.forEach(unit => {
          unit.deviceList.forEach(device => {
            if (checkAll) {
              device.check = true
            } else if (noCheck) {
              device.check = false
            }
          })
        })
      })
    },
    innerChange ({ selectDeviceCount, selectSlotAmount, buildingList }) {
      this.community.tnSelectDeviceCount = selectDeviceCount
      this.community.tnSelectSlotAmount = selectSlotAmount
      this.community.buildDeviceList = buildingList
    },
    outerChange ({ selectDeviceCount, selectSlotAmount, buildingList }) {
      this.community.twSelectDeviceCount = selectDeviceCount
      this.community.twSelectSlotAmount = selectSlotAmount
      this.community.twBuildDeviceList = buildingList
    },
    submitData () {
      let { twSelectDeviceCount, tnSelectDeviceCount, twSelectSlotAmount, tnSelectSlotAmount } = this.community
      this.community.allSelectDeviceCount = tnSelectDeviceCount
      this.community.allSelectSlotAmount = tnSelectSlotAmount
      this.community.check = this.community.allSelectDeviceCount > 0
      this.$emit('change', this.community)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.point_select {
  ::v-deep .el-dialog__header {
    padding: 12px 10px;
    box-shadow: 0 1px 0 0 #e9e9e9;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 16px;
  }
  ::v-deep .el-dialog__body {
    background-color: #F5F5F5;
  }
  ::v-deep .el-dialog__footer {
    padding: 15px 10px;
    box-shadow: 0 -1px 0 0 #e9e9e9;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: inherit;
  }
}
.dialog_title {
  text-align: center;
  color: #282729;
  font-size: 18px;
  line-height: 25px;
}
.screen_type {
  line-height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 233, 233, 1);
  margin-bottom: 10px;
  display: flow-root;
  & > div {
    width: 360px;
    float: left;
    text-align: center;
    color: #999;
    span {
      display: inline-block;
      height: 40px;
      cursor: pointer;
      &.cur {
        border-bottom: 1px solid #282729;
        color: #282729;
        i {
          color: #999999;
        }
      }
    }
  }
  .solid_line {
    width: 1px;
    height: 20px;
    background: #E9E9E9;
    margin-top: 10px;
  }
}
.point_body {
  max-height: 440px;
  background-color: #fff;
  border: 1px solid #EAEBF0;
  overflow-y: auto;
  .hl {
    color: #FF3973;
  }
  .point_all {
    padding: 10px;
    font-size: 14px;
    line-height: 20px;
    border-bottom: 1px solid #EAEBF0;
  }
  .point_rows {
    margin: 10px;
    background-color: #F5F5F5;
    .point_rows_title {
      padding: 10px;
    }
  }
  .point_detail {
    box-shadow: 0 1px 0 0 #e9e9e9;
    .point_item {
      position: relative;
      overflow: hidden;
      .p_i_title {
        display: inline-block;
        color: #282729;
        font-size: 14px;
        line-height: 20px;
        padding: 10px 10px;
        width: 178px;
        box-shadow: 0 1px 0 0 #e9e9e9, 0 1px 0 0 #e9e9e9 inset;
      }
    }
  }
  .point_list {
    float: right;
    display: flex;
    width: calc(100% - 180px);
    justify-content: flex-end;
    flex-wrap: wrap;
    box-shadow: 0 1px 0 0 #e9e9e9 inset;
    .el-checkbox {
      width: 140px;
      height: 40px;
      margin-left: 0;
      padding: 10px 10px;
      box-shadow: 0 1px 0 0 #e9e9e9, -1px 0 0 0 #e9e9e9;
      box-sizing: border-box;
      ::v-deep .el-checkbox__label {
        color: #282729;
        font-size: 14px;
        line-height: 20px;
      }
      &.is-disabled ::v-deep .el-checkbox__label {
        color: #a3a3a3;
      }
    }
  }
  .icon_toggle {
    font-size: 12px;
    color: #999;
    margin-left: 10px;
  }
  .dark {
    color: #282729;
  }
  .ml10 {
    margin-left: 10px;
  }
}
.empty_div {
  line-height: 100px;
  background: #FFF;
  text-align: center;
  color: #999999;
  border: 1px solid #E9E9E9;
}
.p_footer {
  text-align: center;
  .btn {
    width: 120px;
  }
  .sure_btn_x {
    padding: 8px 15px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
  }
}
</style>
